import React from 'react';
import { type VariantProps } from 'class-variance-authority';
import { ShadcnBadge, badgeVariants } from 'shadcn-ui';
import { TextBadgeLayoutProps, TextBadgeVariant } from '../types';

type BadgeVariant = NonNullable<VariantProps<typeof badgeVariants>['variant']>;

const VARIANT_MAP: Record<TextBadgeVariant, BadgeVariant> = {
  [TextBadgeVariant.PRIMARY]: 'blue',
  [TextBadgeVariant.SECONDARY]: 'default',
  [TextBadgeVariant.SUCCESS]: 'active',
  [TextBadgeVariant.WARNING]: 'draft',
  [TextBadgeVariant.ERROR]: 'red',
};

export default function ShadcnTextBadgeLayout(props: TextBadgeLayoutProps) {
  const variant = VARIANT_MAP[props.variant || TextBadgeVariant.PRIMARY];

  return (
    <ShadcnBadge
      variant={variant}
      title={props.title}
      className={props.isSmall ? 'text-[10px] px-1.5 py-0' : undefined}
    >
      {props.text}
    </ShadcnBadge>
  );
}
